import { Box, Flex, Text, Spinner, useBreakpointValue, useToast } from "@chakra-ui/react";
import { useCallback, useEffect, useState } from "react";

import { Header } from "../../../components/Header";
import { Sidebar } from "../../../components/Sidebar";
import { Template, useTemplates } from "../../../services/hooks/useTemplates";
import ContentBase from "../../../components/ContentBase";
import MainBase from "../../../components/MainBase";
import MainActions from "../../../components/MainActions";
import { Column } from "react-table";
import { MainTable } from "../../../components/MainTable";
import { RemoveAccent } from "../../../utils/RemoveAccent";
import { useMutation } from "react-query";
import { api } from "../../../services/api";

export function TemplateList() {
  const toast = useToast();
  const [searchField, setSearchField] = useState("");
  const [allTemplates, setAllTemplates] = useState<Template[]>([]);

  const { data, isLoading, isFetching, error } = useTemplates();

  useEffect(() => {
    if (data) {
      setAllTemplates(data);
    }
  }, [data]);

  const handleChangeSearch = useCallback((event) => {
    setSearchField(event.target.value);
  }, []);

  const handleSearch = useCallback(() => {
    if (data) {
      if (searchField) {
        const searchFieldWithoutAccent = RemoveAccent(
          searchField.toLowerCase()
        );
        const templatesFiltered = data.filter((template) =>
          RemoveAccent(template.title.toLowerCase()).match(
            searchFieldWithoutAccent
          )
        );

        setAllTemplates(templatesFiltered);

        return;
      }

      setAllTemplates(data);
    }
  }, [searchField, data]);

  const handleOnPressEnter = useCallback(
    (event) => {
      if (event.key === "Enter") {
        handleSearch();
      }
    },
    [handleSearch]
  );

  const emailSent = useMutation(async (data: { template: string, layout: string }) => {
    await api.post(`/templates/test`, data);
  });

  const handleSendTestEmail = async (values: { template: string, layout: string }) => {
    try {
      await emailSent.mutateAsync({template: values.template, layout: values.layout});

      toast({
        title: "Email enviado",
        description: "Email enviado com sucesso.",
        status: "success",
        duration: 3000, // 3 seconds,
        isClosable: true,
        position: "top-right",
      })

      window.close()
    } catch (err: any) {
      toast({
        title: "Opa...",
        description: "Ocorreu uma instabilidade. Por favor tente novamente mais tarde.",
        status: "error",
        duration: 3000, // 3 seconds,
        isClosable: true,
        position: "top-right",
      })
    }
  }

  const columns: Column<Template>[] = [
    {
      Header: "Título",
      accessor: "title",
      //  @ts-ignore TYPE NEEDS FIXING
      isSortable: true,
    }
  ];

  const actions = [
    {
      type: "edit",
      url: "/templates/update/<id>",
    },
    {
      type: "email",
      url: "",
      onClick: handleSendTestEmail
    },
  ];

  const isWideVersion = useBreakpointValue({
    base: false,
    lg: true,
  });

  return (
    <Flex direction="column" h="100vh">
      {!isWideVersion && <Header />}

      <ContentBase>
        <Sidebar />

        <MainBase
          mainTitle="Templates"
          isLoading={isLoading}
          isFetching={isFetching}
        >
          <MainActions
            handleChangeSearch={handleChangeSearch}
            handleOnPressEnter={handleOnPressEnter}
            handleSearch={handleSearch}
            searchPlaceHolder="Digite o título que deseja procurar..."
          />

          <Box w="100%" h={["", null, null, "80vh"]}>
            {isLoading ? (
              <Flex justify="center">
                <Spinner color="blue.900" size="xl" />
              </Flex>
            ) : error ? (
              <Flex direction="column">
                <Text fontSize="lg" color="blue.900">
                  Oops...ocorreu uma falha ao obter os templates :(
                </Text>
                <Text fontSize="lg" color="blue.900">
                  Tente novamente ;)
                </Text>
              </Flex>
            ) : (
              <Flex
                w="100%"
                h="100%"
                direction="column"
                justifyContent="space-between"
              >
                <MainTable
                  columns={columns}
                  data={allTemplates}
                  actions={actions}
                />
              </Flex>
            )}
          </Box>
        </MainBase>
      </ContentBase>
    </Flex>
  );
}
